<!--
 * @Author: gaojingran
 * @Date: 2021-03-20 13:40:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-25 16:50:57
 * @Description: Login
-->

<style lang="less" scoped>
@import './index.less';
</style>

<template>
  <NeoScroll class="full">
    <div class="login">
      <div class="login-header">
        <div class="logo"></div>
        <a-icon class="help c-3" type="question-circle" @click="jumpHelp" />
      </div>
      <div class="login-body">
        <div class="container">
          <div class="left">
            <div class="image">
              <img src="~@/assets/image/PM-login-img.png" alt="login" />
            </div>
            <div class="title">
              <span class="divider"></span>
              <span class="text">{{ $t('login.title') }}</span>
              <span class="divider"></span>
            </div>
            <p class="sub-title">{{ $t('login.subTitle') }}</p>
          </div>
          <div class="right">
            <div class="image">
              <img src="~@/assets/image/login-form-img.svg" alt="form" />
            </div>
            <div class="form">
              <div class="form-container">
                <a-form-model ref="loginForm" layout="vertical" :model="form" :rules="rules">
                  <a-form-model-item prop="username">
                    <a-input
                      v-model="form.username"
                      size="large"
                      autocomplete="off"
                      :placeholder="$t('login.form_account_holder')"
                      @keyup.native.enter="handleLogin"
                      @blur="queryTenantCode"
                    >
                      <a-icon class="c-3" slot="prefix" type="mail" />
                    </a-input>
                  </a-form-model-item>
                  <a-form-model-item size="large" prop="password">
                    <a-input
                      v-model="form.password"
                      size="large"
                      type="password"
                      autocomplete="off"
                      :placeholder="$t('login.form_password_holder')"
                      @keyup.native.enter="handleLogin"
                    >
                      <a-icon class="c-3" slot="prefix" type="lock" />
                    </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="bizTenantCode">
                    <a-input
                      v-model="form.bizTenantCode"
                      size="large"
                      autocomplete="off"
                      :placeholder="$t('login.form_tenant_code_holder')"
                      @keyup.native.enter="handleLogin"
                    >
                      <a-icon class="c-3" slot="prefix" type="book" />
                    </a-input>
                  </a-form-model-item>
                  <!-- <a-form-model-item prop="captcha">
                    <div class="verify-item">
                      <a-input
                        size="large"
                        v-model="form.captcha"
                        :placeholder="$t('login.form_verify_holder')"
                        @keyup.native.enter="handleLogin"
                      >
                        <a-icon class="c-3" slot="prefix" type="safety-certificate" />
                      </a-input>
                      <div class="code">
                        <img :src="captchaPath" @click="getCaptcha()" />
                      </div>
                    </div>
                  </a-form-model-item> -->
                </a-form-model>
                <a-button class="login-btn" block type="primary" @click="handleLogin" :loading="loading">
                  {{ $t('login.submit') }}
                </a-button>
                <a-button id="captcha-button" v-show="false"></a-button>
                <div id="captcha-element"></div>
                <div class="careful">
                  <p class="sub-title bold">{{ $t('login.chrome') }}</p>
                  <a class="fr" type="link" @click="forgetVisible = true"> {{ $t('login.forget_password') }}? </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="login-footer">
        <div class="footer-content">
          <p class="copyright">{{ $t('footer.copyright') }}</p>
          <p class="icp" v-if="customText">{{ customText }}</p>
        </div>
      </div>
      <!-- 忘记密码 -->
      <ForgetPassword :visible.sync="forgetVisible" />
    </div>
  </NeoScroll>
</template>

<script>
import Cookies from 'js-cookie'
import { storage } from '@/utils/storage'
import { uuid, passwordRegex, getDomainBasedCustomText, getBaseUrlBySiteConfig } from '@/utils/utils'
import ForgetPassword from './components/ForgetPassword'
import md5 from 'js-md5'
const { validate, storageKey } = window.$g

export default {
  name: 'Login',
  components: {
    ForgetPassword,
  },
  data() {
    return {
      customText: getDomainBasedCustomText(),
      forgetVisible: false,
      loading: false,
      captchaPath: '',
      form: {
        username: storage.get(this.userInfoKey)?.username || '',
        password: '',
        captcha: '',
        uuid: '',
        client: undefined,
        supplier: undefined,
        bizTenantCode: storage.get(this.userInfoKey)?.bizTenantCode || '',
      },
      cusEntity: [],
      supplierEntity: [],
      rules: {
        username: [validate.required],
        password: [validate.required, validate.min_string_6],
        bizTenantCode: [validate.required],
        captcha: [
          {
            required: true,
            message: this.$t('login.noverify'),
          },
        ],
      },
    }
  },
  computed: {
    userInfoKey() {
      return `GientCloud-username_${this.form.username}`
    },
    userInfo() {
      return storage.get(this.userInfoKey)
    },
  },
  mounted() {
    this.initCaptcha()
  },
  methods: {
    queryTenantCode() {
      const has = storage.has(this.userInfoKey)
      console.log(`has`, has)
      if (has) {
        const data = storage.get(this.userInfoKey)
        console.log(`data`, data)
        const bizTenantCode = data?.bizTenantCode
        this.form.bizTenantCode = bizTenantCode
      } else {
        this.form.bizTenantCode = ''
      }
    },
    // 获取验证码
    getCaptcha() {
      const baseUrl = getBaseUrlBySiteConfig('apiURL')
      this.form.uuid = uuid()
      this.captchaPath = `${baseUrl}${window.$g.api['auth_captcha_no_method']}?uuid=${this.form.uuid}`
    },
    // 登录
    handleLogin() {
      if (this.loading) return
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            document.getElementById('captcha-button').click()
          } catch (err) {
            this.loading = false
            this.form.captcha = ''
            this.initCaptcha()
            this.$httpNotify(err)
          }
        }
      })
    },

    jumpHelp() {
      const gcBaseUrl = getBaseUrlBySiteConfig('gcURL')
      window.open(`${gcBaseUrl}/instruction/story.html`, '_blank', 'noopener,noreferrer')
    },
    // 绑定验证码实例函数。该函数为固定写法，无需修改
    getInstance(instance) {
      this.captchaInstance = instance

      // 移除已存在的点击事件处理函数
      if (this._clickHandler) {
        document.removeEventListener('click', this._clickHandler)
      }

      // 创建新的点击事件处理函数
      this._clickHandler = (e) => {
        // 检查是否点击了关闭按钮
        const target = e.target
        const targetClass = target.className || ''

        if (
          // 检查是否点击了关闭按钮
          targetClass.includes('aliyunCaptcha-btn-close') ||
          target.id === 'aliyunCaptcha-btn-close' ||
          // 检查是否点击了蒙版
          targetClass.includes('aliyunCaptcha-mask') ||
          target.id === 'aliyunCaptcha-mask'
        ) {
          console.log('点击了关闭按钮')

          // 隐藏验证码弹窗
          if (this.captchaInstance && typeof this.captchaInstance.hide === 'function') {
            this.captchaInstance.hide()
          }
          // 处理验证码关闭后的逻辑
          this.loading = false
        }
      }

      // 添加点击事件监听器
      document.addEventListener('click', this._clickHandler, true)
    },
    async captchaVerifyCallback(captchaVerifyParam) {
      try {
        let submitForm = JSON.parse(JSON.stringify(this.form))
        submitForm.systemType = window.$g.systemType.order
        submitForm.userType = window.$g.userType.sup
        submitForm.password = md5(submitForm.password)
        submitForm.uuid = uuid()
        submitForm.captcha = '123456'
        submitForm.region = 'cn'

        const params = {
          captchaVerifyParam: captchaVerifyParam,
          data: submitForm,
        }
        const data = await this.$http('login', params)
        // 记录账号
        const { username, bizTenantCode } = this.form
        const userInfo = {
          username,
          bizTenantCode,
        }
        storage.set(this.userInfoKey, userInfo)
        // token
        Cookies.set(storageKey.TOKEN, data.token)
        // 校验密码是否符合规范
        Cookies.set('isPasswordValid', passwordRegex.test(this.form.password))
        const verifyResult = {
          captchaResult: data.captchaResult,
          bizResult: true,
        }
        this.loading = false
        return verifyResult
      } catch (error) {
        this.$message.error(error.msg)
        console.error('验证码验证失败:', error)
        // 清理DOM
        const mask = document.getElementById('aliyunCaptcha-mask')
        const popup = document.getElementById('aliyunCaptcha-window-popup')
        if (mask) mask.remove()
        if (popup) popup.remove()
        await this.initCaptcha()
        this.loading = false
      }
    },
    onBizResultCallback() {
      // 进系统
      this.$router.replace({ name: 'main' })
      this.loading = false
    },
    // 初始化验证码
    async initCaptcha() {
      try {
        // 尝试销毁已存在的实例
        if (this.captchaInstance) {
          try {
            // 先移除DOM元素
            const mask = document.getElementById('aliyunCaptcha-mask')
            const popup = document.getElementById('aliyunCaptcha-window-popup')
            if (mask) mask.remove()
            if (popup) popup.remove()
            this.captchaInstance = null
          } catch (e) {
            console.error('销毁验证码实例失败:', e)
          }
        }

        // 确保必要的环境变量存在
        if (!process.env.VUE_APP_SCENE_ID || !process.env.VUE_APP_PREFIX) {
          console.error('验证码配置缺失')
          return
        }

        // 初始化验证码
        window.initAliyunCaptcha({
          SceneId: process.env.VUE_APP_SCENE_ID,
          prefix: process.env.VUE_APP_PREFIX,
          mode: 'popup',
          element: '#captcha-element',
          button: '#captcha-button',
          captchaVerifyCallback: this.captchaVerifyCallback,
          onBizResultCallback: this.onBizResultCallback,
          getInstance: this.getInstance,
          slideStyle: {
            width: 320,
            height: 40,
          },
          region: 'cn',
          language: 'en',
        })
      } catch (error) {
        console.error('初始化验证码失败:', error)
        // 可以在这里添加错误提示
        this.$message.error('验证码初始化失败，请刷新页面重试')
      }
    },
  },
}
</script>
